module.exports = __webpack_public_path__ + "files/c5489f5861285c1c40f2696915b6690e.svg";